import { Box, Chip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "./styles.module.css";
import { useParams } from "react-router-dom";
import { useTheme } from "../../../../../context/themeContext";
import axios from "axios";
import { node_server } from "../../../../../constants";

const Collaborate = () => {
  const { theme } = useTheme();
  const [collaborators, setCollaborators] = useState([]);
  const [ageRagnes, setAgeRanges] = useState([]);
  const { id } = useParams();
  

  useEffect(() => {
    const fetchCollaborators = async () => {
      const { data, error } = await axios.get(
        `${node_server}/api/profile/${id}/about`,
        { withCredentials: true },
      );

      if (error) console.log(error);
      const { collaborators, ageRanges } = data;
      setCollaborators(collaborators);
      setAgeRanges(ageRanges);
    };

    fetchCollaborators();
  }, [id]);

  return (
    <Box
      className={styles.communityStatus}
      sx={{
        bgcolor: theme.palette.lightgrey.lightgrey00,
      }}
    >
      <Box className={styles.content}>
        <Typography
          variant="body"
          className={styles.heading}
          sx={{ color: theme.palette.darkgrey.darkgrey600 }}
        >
          I am looking to collaborate with:
        </Typography>
        <Box
          className={styles.tags}
          sx={{
            flexWrap: "wrap",
          }}
        >
          {collaborators.map((collaborate, index) => (
            <Chip key={collaborate.type} label={collaborate.display_name} />
          ))}
        </Box>
      </Box>
      <Box className={styles.content}>
        <Typography
          variant="body"
          className={styles.heading}
          sx={{ color: theme.palette.darkgrey.darkgrey600 }}
        >
          Age Range
        </Typography>
        <Box
          className={styles.tags}
          sx={{
            flexWrap: "wrap",
          }}
        >
          {ageRagnes.map((item) => {
            return (
              <Chip
                label={`Gen ${item.age_category}`}
                key={item.age_category}
              />
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default Collaborate;
